import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class StudentSelectModel {
	constructor(studentListModel) {
		this.students = new Set();
		this.selected = new signals.Signal();
		studentListModel.removed.add(this.studentRemoved, this);
		this.allStudentsList = studentListModel;
	}
	studentRemoved(student, src) {
		this.select(student.Id, false, src);
	}
	toggle(student, src=null) {
		this.select(student, !this.students.has(student), src);
	}
	// selectFor selects students based on the returned value from
	// the filterF parameter. If the union parameter is true, 
	// any previously selected students remain selected, otherwise
	// only the students matching the filter function are selected.
	selectFor(filterF, union=true, src=null) {
		for (let s of this.allStudentsList) {
			if (filterF(s)) {
				this.select(s,true,src);
			} else {
				if (!union) {
					this.select(s,false,src);
				}
			}
		}
	}
	select(student, selected=true, src=null) {
		let dispatch = false;
		let found = this.students.has(student);
		if (selected && !found) {
			this.students.add(student);
			dispatch = true;
		}
		if (!selected && found) {
			this.students.delete(student);
			dispatch  =true;
		}
		if (dispatch) {
			console.log("Dispatching StudentSelectModel update");
			this.selected.dispatch(student, selected, src);
		}
	}
	clear(src=null) {
		for (let s of this.students) {
			this.selected.dispatch(s, false, src);
		}
		this.students.clear();
	}
	[Symbol.iterator]() {
		return this.students[Symbol.iterator]();
	}
	idArray() {
		let arr = [];
		for (let s of this.students) {
			arr.push(s.Id);
		}
		return arr;
	}
	toArray() {
		let arr = [];
		for (let s of this.students) {
			arr.push(s);
		}
		return arr;
	}
}